export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "article/list",
            name: "articleList",
            component: resolve => require(["@/modules/article/pages/list.vue"], resolve),
            meta: {
              nameText: "文章列表",
            },
          },
          {
            path: "article/edit/:id",
            name: "articleEdit",
            component: resolve => require(["@/modules/article/pages/edit.vue"], resolve),
            meta: {
              nameText: "创建文章",
            },
          },
          {
            path: "article/aiEdit",
            name: "articleAiEdit",
            component: resolve => require(["@/modules/article/pages/aiEdit.vue"], resolve),
            meta: {
              nameText: "AI创建文章",
            },
          },
          {
            path: "article/report/:id",
            name: "articleReport",
            component: resolve => require(["@/modules/article/pages/report.vue"], resolve),
            meta: {
              nameText: "文章统计",
            },
          },
          {
            path: "article/template",
            name: "articleTemplate",
            component: resolve => require(["@/modules/article/pages/template.vue"], resolve),
            meta: {
              nameText: "文章模板",
            },
          },
          {
            path: "article/templateEdit/:id",
            name: "articleTemplateEdit",
            component: resolve => require(["@/modules/article/pages/templateEdit.vue"], resolve),
            meta: {
              nameText: "编辑模板",
            },
          },
          {
            path: "article/listall",
            name: "articleListAll",
            component: resolve => require(["@/modules/article/pages/listAll.vue"], resolve),
            meta: {
              nameText: "公共文章池",
            },
          },
          {
            path: "article/type",
            name: "articleType",
            component: resolve => require(["@/modules/article/pages/type.vue"], resolve),
            meta: {
              nameText: "文章分类",
            },
          },
          {
            path: "article/subject",
            name: "articleSubject",
            component: resolve => require(["@/modules/article/pages/subject.vue"], resolve),
            meta: {
              nameText: "文章专题",
            },
          },
          {
            path: "article/subject/edit",
            name: "articleSubjectEdit",
            component: resolve => require(["@/modules/article/pages/subjectEdit.vue"], resolve),
            meta: {
              nameText: "编辑专题",
            },
          },
        ],
      },
    ],
  },
]
